<template>
  <div>
    <e-dialog
      dialogTitle="关联单据"
      :centerDialogVisible="visible"
      @resetPopupData="resetPopupData"
      :show-btn="false"
      :only-show-cancel="true"
      cancel-button-tip="关 闭"
      :popupWidth="'420px'">
      <div class="dialog-content">
        <div>
          {{info.businessType === 1 ? '对账单编号' : '询价单号'}}：
        </div>
        <div>
          <div :class="{theme: info.businessType === 1}"
               v-for="item in list" :key="item.businessNo" @click="toDetails(item)">{{item.businessNo}}
          </div>
        </div>
      </div>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/components/common/e-dialog';
import Api from '@/modules/projectA/api/order';

export default {
  name: 'relatedOrdersDialog',
  components: { eDialog },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        Api.statementAccountList({ chargeNoticeId: this.info.chargeNoticeId }).then(res => {
          if (res.code === '200') {
            this.list = res.data;
          }
        });
      }
    }
  },
  data() {
    return {
      list: []
    };
  },
  methods: {
    resetPopupData() {
      this.$emit('update:visible', false);
    },
    toDetails(data) {
      if (this.info.businessType !== 1) {
        return;
      }
      this.$router.push({
        path: '/statementDetails',
        query: {
          statementAccountId: data.businessId,
          supplierCompanyId: this.info.payerCompanyId,
          isCancelOrNot: 0
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/theme.scss";

.dialog-content {
  font-family: Source Han Sans CN;
  font-size: 14px;
  font-style: normal;
  font-weight: 350;
  display: flex;
  min-height: 50px;

  .theme {
    color: $main-col;
    cursor: pointer;
  }
}
</style>